module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/marquee_mobile1-0cd968d9d87de6c7ba315f7f567d97db.jpg";